module.exports = __webpack_public_path__ + "static/media/sandwich.2579fd70.svg";